import React from 'react';
import PropTypes from 'prop-types';

import Numeral, { NumeralTypes } from '../numeral.component';

const PercentageRenderer = ({ value }) => (
  <Numeral type={NumeralTypes.PERCENTAGE}>{value}</Numeral>
);

PercentageRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
};

export default PercentageRenderer;
